import Resource from "../../shared/actions/resourceActions";

export default class MasterDataResource extends Resource {
  constructor(dispatch) {
    super(dispatch, "master_data", "/api/v1/master_data");
  }
}
